import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Image3D } from "@dreamcam/babylon-tools";
import { Env } from "../../settings/Env";
export class VideoTagsPurchasesPanel {
    constructor(parent, mesh2d) {
        this._parent = parent;
        const p = Env.lobby.tagsPanel.purchases;
        const image = new Image3D("videoTagsPurchasesBanner", p.banner.src);
        image.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_CENTER;
        image.verticalAlignment = Container.VERTICAL_ALIGNMENT_TOP;
        image.widthInPixels = mesh2d.m2px(p.banner.width);
        image.heightInPixels = mesh2d.m2px(p.banner.height);
        image.topInPixels = mesh2d.m2px(p.banner.top);
        parent.addControl(image);
        // const descriptionTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, "videoTagsPurchasesDescription",
        //     text.lobby_video_tags_purchases_description, p.description);
        // parent.addControl(descriptionTextBlock);
    }
    get isVisible() {
        return this._parent.isVisible;
    }
    set isVisible(value) {
        this._parent.isVisible = value;
    }
}
